var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 16
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.875C6.75 15.0408 6.68415 15.1997 6.56694 15.3169C6.44973 15.4342 6.29076 15.5 6.125 15.5H1.75C1.41848 15.5 1.10054 15.3683 0.866116 15.1339C0.631696 14.8995 0.5 14.5815 0.5 14.25V1.75C0.5 1.41848 0.631696 1.10054 0.866116 0.866116C1.10054 0.631696 1.41848 0.5 1.75 0.5H6.125C6.29076 0.5 6.44973 0.565848 6.56694 0.683058C6.68415 0.800269 6.75 0.95924 6.75 1.125C6.75 1.29076 6.68415 1.44973 6.56694 1.56694C6.44973 1.68415 6.29076 1.75 6.125 1.75H1.75V14.25H6.125C6.29076 14.25 6.44973 14.3158 6.56694 14.4331C6.68415 14.5503 6.75 14.7092 6.75 14.875ZM15.3172 7.55781L12.1922 4.43281C12.0749 4.31554 11.9159 4.24965 11.75 4.24965C11.5841 4.24965 11.4251 4.31554 11.3078 4.43281C11.1905 4.55009 11.1247 4.70915 11.1247 4.875C11.1247 5.04085 11.1905 5.19991 11.3078 5.31719L13.3664 7.375H6.125C5.95924 7.375 5.80027 7.44085 5.68306 7.55806C5.56585 7.67527 5.5 7.83424 5.5 8C5.5 8.16576 5.56585 8.32473 5.68306 8.44194C5.80027 8.55915 5.95924 8.625 6.125 8.625H13.3664L11.3078 10.6828C11.1905 10.8001 11.1247 10.9591 11.1247 11.125C11.1247 11.2909 11.1905 11.4499 11.3078 11.5672C11.4251 11.6845 11.5841 11.7503 11.75 11.7503C11.9159 11.7503 12.0749 11.6845 12.1922 11.5672L15.3172 8.44219C15.3753 8.38414 15.4214 8.31521 15.4529 8.23934C15.4843 8.16346 15.5005 8.08214 15.5005 8C15.5005 7.91787 15.4843 7.83654 15.4529 7.76066C15.4214 7.68479 15.3753 7.61586 15.3172 7.55781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.0f815f290be3bf19ff45b696a1476696.svg";
export { ForwardRef as ReactComponent };